import { Phone, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const HeroSection = () => {
  const { language } = useLanguage();
  const t = translations[language].hero;
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="fooldal" className="relative min-h-screen flex items-center pt-16">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80" 
          alt="Ház felújítás" 
          className="w-full h-full object-cover" 
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#4A1C24]/90 to-[#5A2229]/75"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 py-20">
        <div className="max-w-2xl space-y-6">
          <span className="inline-block px-4 py-2 rounded-full bg-[#7B2F3D]/20 text-white text-sm font-semibold backdrop-blur-sm border border-white/20">
            {t.badge}
          </span>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight">
            {t.title1} <br />
            <span className="text-gray-100">{t.title2}</span>
          </h1>
          
          <p className="text-lg text-white max-w-lg">
            {t.description}
          </p>
          
          <div className="flex flex-wrap gap-4 pt-4">
            <button
              onClick={() => scrollToSection('idopontfoglalas')}
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg bg-[#7B2F3D] text-white font-bold hover:bg-[#6A2835] transition-colors shadow-lg"
            >
              {t.bookingBtn}
              <ArrowRight className="w-5 h-5" />
            </button>
            
            <a
              href="tel:+36702378089"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg border-2 border-white/30 text-white font-semibold hover:bg-white/10 transition-colors backdrop-blur-sm"
            >
              <Phone className="w-5 h-5" />
              {t.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;